type Accent = "primary" | "accent" | "secondary" | "emerald" | "amber" | "rose";

const ACCENT_CLASS: Record<Accent, string> = {
  primary:   "bg-primary-50 text-primary-600",
  accent:    "bg-accent-50 text-accent-600",
  secondary: "bg-secondary-50 text-secondary-600",
  emerald:   "bg-emerald-50 text-emerald-600",
  amber:     "bg-amber-50 text-amber-600",
  rose:      "bg-rose-50 text-rose-600",
};

interface AdminStatCardProps {
  label: string;
  value: string | number;
  icon: string;
  accent?: Accent;
  sub?: string;
}

export default function AdminStatCard({
  label,
  value,
  icon,
  accent = "primary",
  sub,
}: AdminStatCardProps) {
  return (
    <div className="flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-5">
      <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${ACCENT_CLASS[accent]}`}>
        <i className={`${icon} text-xl`} />
      </div>
      <div className="min-w-0">
        <p className="font-heading text-2xl font-bold tabular-nums text-foreground-950">{value}</p>
        <p className="truncate text-xs text-foreground-500">{label}</p>
        {sub && <p className="text-[11px] text-foreground-400">{sub}</p>}
      </div>
    </div>
  );
}